import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../shared/dataservice.service';
import { EnggDrawKpiComponent } from './engg-draw-kpi/engg-draw-kpi.component';
import { MarketingKpiComponent } from './marketing-kpi/marketing-kpi.component';
import * as XLSX from 'xlsx';
import { EnggProcureKpiComponent } from './engg-procure-kpi/engg-procure-kpi.component';
import { PmTechnicalSuborderKpiComponent } from './pm-technical-suborder-kpi/pm-technical-suborder-kpi.component';
import { ScmKpiComponent } from './scm-kpi/scm-kpi.component';
import { PlanningKpiComponent } from './planning-kpi/planning-kpi.component';
import { PurchaseMaterialReceiptKpiComponent } from './purchase-material-receipt-kpi/purchase-material-receipt-kpi.component';
import { StoreKpiComponent } from './store-kpi/store-kpi.component';
import { QualityKpiComponent } from './quality-kpi/quality-kpi.component';
import { LogisticKpiComponent } from './logistic-kpi/logistic-kpi.component';
import { ProductionKpiComponent } from './production-kpi/production-kpi.component';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-kpis-v3',
  templateUrl: './kpis-v3.component.html',
  styleUrls: ['./kpis-v3.component.css']
})
export class KpisV3Component implements OnInit {
  @ViewChild(MarketingKpiComponent,{static: false}) mktData: MarketingKpiComponent;
  @ViewChild(EnggDrawKpiComponent,{static: false}) enggData: EnggDrawKpiComponent;
  @ViewChild(EnggProcureKpiComponent,{static: false}) enggProcData: EnggProcureKpiComponent;
  @ViewChild(PmTechnicalSuborderKpiComponent,{static: false}) pmTechData: PmTechnicalSuborderKpiComponent;
  @ViewChild(ScmKpiComponent,{static: false}) scmData: ScmKpiComponent;
  @ViewChild(PlanningKpiComponent,{static: false}) planningData: PlanningKpiComponent;
  @ViewChild(PurchaseMaterialReceiptKpiComponent,{static: false}) purchaseMatRecpData: PurchaseMaterialReceiptKpiComponent;
  @ViewChild(StoreKpiComponent,{static: false}) storeData: StoreKpiComponent;
  @ViewChild(ProductionKpiComponent,{static: false}) productionData: ProductionKpiComponent;
  @ViewChild(QualityKpiComponent,{static: false}) qualityData: QualityKpiComponent;
  @ViewChild(LogisticKpiComponent,{static: false}) logisticData: LogisticKpiComponent;
  @ViewChild('userImpFormFunct',{static: false}) userImpFormFunct;

  obj: any = [];

  constructor(public _dataService: DataService) { }

  ngOnInit() {
    this._dataService.currPageName = 'Functional KPI';
  }
  exportToExcel() {

    let _templateHeaderSORelease = []; let _templateHeaderHOM = [];
    let _templateHeaderSLD = []; let _templateHeaderGA = []; let _templateHeaderSCHEME = [];
    let _templateHeaderC40 = []; let _templateHeaderC50 = []; let _templateHeaderC60 = [];
    let _templateHeaderDrawAppvl = [];
    let _templateHeaderSCM = [];
    let _templateHeaderPickList = [];
    let _templateHeaderCTRecpt = []; let _templateHeaderBreaker = []; let _templateHeaderRelay = []; let _templateHeaderMB = [];
    let _templateHeaderMatDisp = []; let _templateHeaderMatLine = [];
    let _templateHeaderActLineLoad = []; let _templateHeaderMechStk = [];
    let _templateHeaderMechElec = []; let _templateHeaderFAT = []; let _templateHeaderGreenStk = [];
    let _templateHeaderDisp = [];

    /// SO Release
    let resSO = [];
    if (this.mktData.mktKpi != null) {
      let _tmpSO = this.mktData.mktKpi.filter(e => e.kpiName.match("SO Release"));
      let _flag:boolean = false;
      _tmpSO.forEach((e) => {
        if (e.plannedDate != null && e.actualDate != null) {
          _flag = true;
        }
        else{
          _flag = false;
        }
      });
      
      if(_flag != false){
      let resSOTmp = _tmpSO.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
        ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
      _templateHeaderSORelease = this.templateHeader(1);
      for (let i = 0; i < resSOTmp.length; i++) {
        let _tmp = Object.values(resSOTmp[i]);
        for (var j = 0; j < _tmp.length; j++) {
          if (_tmp[j] != null && typeof _tmp[j] === 'object') {
            _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
          }
        }
        resSO.push(_tmp);
      }
    }
    }
    /// HOM
    let resHom = [];
    if (this.mktData.mktKpi != null) {
      let _tmpHom = this.mktData.mktKpi.filter(e => e.kpiName.match("HOM"));
      let _flag:boolean = false;
      _tmpHom.forEach((e) => {
        if (e.plannedDate != null && e.actualDate != null) {
          _flag = true;
        }
        else{
          _flag = false;
        }
      });
      if(_flag != false){
      let resHomTmp = _tmpHom.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
        ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
      _templateHeaderHOM = this.templateHeader(1);
      for (let i = 0; i < resHomTmp.length; i++) {
        let _tmp = Object.values(resHomTmp[i]);
        for (var j = 0; j < _tmp.length; j++) {
          if (_tmp[j] != null && typeof _tmp[j] === 'object') {
            _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
          }
        }
        resHom.push(_tmp);
      }
    }
    }
    /// SLD 
    let resSLD = [];
    if (this.enggData.EnggDrawKpi != null) {
      let _tmpSLD = this.enggData.EnggDrawKpi.filter(e => e.kpiName.match("SLD"));
      let _plannedFlagSLD = []; let _revisedFlagSLD = [];
      _tmpSLD.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagSLD.push(true);
        }
        else { _plannedFlagSLD.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagSLD.push(true);
        }
        else { _revisedFlagSLD.push(false); }
      });

      if (_plannedFlagSLD.includes(true) && _revisedFlagSLD.includes(true)) {
        _templateHeaderSLD = this.templateHeader(4);
        let resSLD1 = _tmpSLD.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resSLD1.length; i++) {
          let _tmp = Object.values(resSLD1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resSLD.push(_tmp);
        }
      }
      else if (_plannedFlagSLD.includes(true) && _revisedFlagSLD.includes(false)) {
        _templateHeaderSLD = this.templateHeader(1);
        let resSLD1 = _tmpSLD.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resSLD1.length; i++) {
          let _tmp = Object.values(resSLD1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resSLD.push(_tmp);
        }
      }
      else if (_plannedFlagSLD.includes(false) && _revisedFlagSLD.includes(true)) {
        _templateHeaderSLD = this.templateHeader(2);
        let resSLD1 = _tmpSLD.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resSLD1.length; i++) {
          let _tmp = Object.values(resSLD1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resSLD.push(_tmp);
        }
      }
    }
    /// GA
    let resGA = [];
    if (this.enggData.EnggDrawKpi != null) {
      let _tmpGA = this.enggData.EnggDrawKpi.filter(e => e.kpiName.match("GA"));
      let _plannedFlagGA = []; let _revisedFlagGA = [];
      _tmpGA.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagGA.push(true);
        }
        else { _plannedFlagGA.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagGA.push(true);
        }
        else { _revisedFlagGA.push(false); }
      });

      if (_plannedFlagGA.includes(true) && _revisedFlagGA.includes(true)) {
        _templateHeaderGA = this.templateHeader(4);
        let resGA1 = _tmpGA.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resGA1.length; i++) {
          let _tmp = Object.values(resGA1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resGA.push(_tmp);
        }
      }
      else if (_plannedFlagGA.includes(true) && _revisedFlagGA.includes(false)) {
        _templateHeaderGA = this.templateHeader(1);
        let resGA1 = _tmpGA.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resGA1.length; i++) {
          let _tmp = Object.values(resGA1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resGA.push(_tmp);
        }
      }
      else if (_plannedFlagGA.includes(false) && _revisedFlagGA.includes(true)) {
        _templateHeaderGA = this.templateHeader(2);
        let resGA1 = _tmpGA.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resGA1.length; i++) {
          let _tmp = Object.values(resGA1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resGA.push(_tmp);
        }
      }
    }

    /// SCHEME
    let resSCHEME = [];
    if (this.enggData.EnggDrawKpi != null) {
      let _tmpSCHEME = this.enggData.EnggDrawKpi.filter(e => e.kpiName.match("SCHEME"));
      let _plannedFlagSCHEME = []; let _revisedFlagSCHEME = [];
      _tmpSCHEME.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagSCHEME.push(true);
        }
        else { _plannedFlagSCHEME.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagSCHEME.push(true);
        }
        else { _revisedFlagSCHEME.push(false); }
      });
      if (_plannedFlagSCHEME.includes(true) && _revisedFlagSCHEME.includes(true)) {
        _templateHeaderSCHEME = this.templateHeader(4);
        let resSCHEME1 = _tmpSCHEME.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resSCHEME1.length; i++) {
          let _tmp = Object.values(resSCHEME1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resSCHEME.push(_tmp);
        }
      }
      else if (_plannedFlagSCHEME.includes(true) && _revisedFlagSCHEME.includes(false)) {
        _templateHeaderSCHEME = this.templateHeader(1);
        let resSCHEME1 = _tmpSCHEME.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resSCHEME1.length; i++) {
          let _tmp = Object.values(resSCHEME1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resSCHEME.push(_tmp);
        }
      }
      else if (_plannedFlagSCHEME.includes(false) && _revisedFlagSCHEME.includes(true)) {
        _templateHeaderSCHEME = this.templateHeader(2);
        let resSCHEME1 = _tmpSCHEME.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resSCHEME1.length; i++) {
          let _tmp = Object.values(resSCHEME1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resSCHEME.push(_tmp);
        }
      }
    }
    /// C40
    let resC40 = [];
    if (this.enggProcData.EnggProcureKpi != null) {
      let _tmpC40 = this.enggProcData.EnggProcureKpi.filter(e => e.kpiName.match("C40"));
      let _plannedFlagC40 = []; let _revisedFlagC40 = [];
      _tmpC40.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagC40.push(true);
        }
        else { _plannedFlagC40.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagC40.push(true);
        }
        else { _revisedFlagC40.push(false); }
      });

      if (_plannedFlagC40.includes(true) && _revisedFlagC40.includes(true)) {
        _templateHeaderC40 = this.templateHeader(4);
        let resC401 = _tmpC40.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resC401.length; i++) {
          let _tmp = Object.values(resC401[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resC40.push(_tmp);
        }
      }
      else if (_plannedFlagC40.includes(true) && _revisedFlagC40.includes(false)) {
        _templateHeaderC40 = this.templateHeader(1);
        let resC401 = _tmpC40.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resC401.length; i++) {
          let _tmp = Object.values(resC401[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resC40.push(_tmp);
        }
      }
      else if (_plannedFlagC40.includes(false) && _revisedFlagC40.includes(true)) {
        _templateHeaderC40 = this.templateHeader(2);
        let resC401 = _tmpC40.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resC401.length; i++) {
          let _tmp = Object.values(resC401[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resC40.push(_tmp);
        }
      }
    }
    /// C50
    let resC50 = [];
    if (this.enggProcData.EnggProcureKpi != null) {
      let _tmpC50 = this.enggProcData.EnggProcureKpi.filter(e => e.kpiName.match("C50"));
      let _plannedFlagC50 = []; let _revisedFlagC50 = [];
      _tmpC50.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagC50.push(true);
        }
        else { _plannedFlagC50.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagC50.push(true);
        }
        else { _revisedFlagC50.push(false); }
      });

      if (_plannedFlagC50.includes(true) && _revisedFlagC50.includes(true)) {
        _templateHeaderC50 = this.templateHeader(4);
        let resC501 = _tmpC50.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resC501.length; i++) {
          let _tmp = Object.values(resC501[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resC50.push(_tmp);
        }
      }
      else if (_plannedFlagC50.includes(true) && _revisedFlagC50.includes(false)) {
        _templateHeaderC50 = this.templateHeader(1);
        let resC501 = _tmpC50.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resC501.length; i++) {
          let _tmp = Object.values(resC501[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resC50.push(_tmp);
        }
      }
      else if (_plannedFlagC50.includes(false) && _revisedFlagC50.includes(true)) {
        _templateHeaderC50 = this.templateHeader(2);
        let resC501 = _tmpC50.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resC501.length; i++) {
          let _tmp = Object.values(resC501[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resC50.push(_tmp);
        }
      }
    }
    /// C60
    let resC60 = [];
    if (this.enggProcData.EnggProcureKpi != null) {
      let _tmpC60 = this.enggProcData.EnggProcureKpi.filter(e => e.kpiName.match("C60"));
      let _plannedFlagC60 = []; let _revisedFlagC60 = [];
      _tmpC60.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagC60.push(true);
        }
        else { _plannedFlagC60.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagC60.push(true);
        }
        else { _revisedFlagC60.push(false); }
      });

      if (_plannedFlagC60.includes(true) && _revisedFlagC60.includes(true)) {
        _templateHeaderC60 = this.templateHeader(4);
        let resC601 = _tmpC60.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resC601.length; i++) {
          let _tmp = Object.values(resC601[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resC60.push(_tmp);
        }
      }
      else if (_plannedFlagC60.includes(true) && _revisedFlagC60.includes(false)) {
        _templateHeaderC60 = this.templateHeader(1);
        let resC601 = _tmpC60.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resC601.length; i++) {
          let _tmp = Object.values(resC601[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resC60.push(_tmp);
        }
      }
      else if (_plannedFlagC60.includes(false) && _revisedFlagC60.includes(true)) {
        _templateHeaderC60 = this.templateHeader(2);
        let resC601 = _tmpC60.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resC601.length; i++) {
          let _tmp = Object.values(resC601[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resC60.push(_tmp);
        }
      }
    }
    /// PM
    let resPM = [];
    if (this.pmTechData.PmTechnicalSuborderKpi != null) {
      let _tmpPM = this.pmTechData.PmTechnicalSuborderKpi.filter(e => e.kpiName.match("PM"));
      let _plannedFlagPM = []; let _revisedFlagPM = [];
      _tmpPM.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagPM.push(true);
        }
        else { _plannedFlagPM.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagPM.push(true);
        }
        else { _revisedFlagPM.push(false); }
      });

      if (_plannedFlagPM.includes(true) && _revisedFlagPM.includes(true)) {
        _templateHeaderDrawAppvl = this.templateHeader(4);
        let resPM1 = _tmpPM.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resPM1.length; i++) {
          let _tmp = Object.values(resPM1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resPM.push(_tmp);
        }
      }
      else if (_plannedFlagPM.includes(true) && _revisedFlagPM.includes(false)) {
        _templateHeaderDrawAppvl = this.templateHeader(1);
        let resPM1 = _tmpPM.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resPM1.length; i++) {
          let _tmp = Object.values(resPM1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resPM.push(_tmp);
        }
      }
      else if (_plannedFlagPM.includes(false) && _revisedFlagPM.includes(true)) {
        _templateHeaderDrawAppvl = this.templateHeader(2);
        let resPM1 = _tmpPM.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resPM1.length; i++) {
          let _tmp = Object.values(resPM1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resPM.push(_tmp);
        }
      }
    }
    /// CT Finalization
    let resSCM = [];
    if (this.scmData.ScmKpi != null) {
      let _tmpSCM = this.scmData.ScmKpi.filter(e => e.kpiName.match("SCM"));
      let _plannedFlagSCM = []; let _revisedFlagSCM = [];
      _tmpSCM.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagSCM.push(true);
        }
        else { _plannedFlagSCM.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagSCM.push(true);
        }
        else { _revisedFlagSCM.push(false); }
      });

      if (_plannedFlagSCM.includes(true) && _revisedFlagSCM.includes(true)) {
        _templateHeaderSCM = this.templateHeader(4);
        let resSCM1 = _tmpSCM.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resSCM1.length; i++) {
          let _tmp = Object.values(resSCM1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resSCM.push(_tmp);
        }
      }
      else if (_plannedFlagSCM.includes(true) && _revisedFlagSCM.includes(false)) {
        _templateHeaderSCM = this.templateHeader(1);
        let resSCM1 = _tmpSCM.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resSCM1.length; i++) {
          let _tmp = Object.values(resSCM1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resSCM.push(_tmp);
        }
      }
      else if (_plannedFlagSCM.includes(false) && _revisedFlagSCM.includes(true)) {
        _templateHeaderSCM = this.templateHeader(2);
        let resSCM1 = _tmpSCM.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resSCM1.length; i++) {
          let _tmp = Object.values(resSCM1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resSCM.push(_tmp);
        }
      }
    }

    /// Planning
    let resPickList = [];
    if (this.planningData.PlanningKpi != null) {
      let _tmpPickList = this.planningData.PlanningKpi.filter(e => e.kpiName.match("Pick List"));
      let _plannedFlagPickList = []; let _revisedFlagPickList = []; let _requestedFlagPickList = [];
      _tmpPickList.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagPickList.push(true);
        }
        else { _plannedFlagPickList.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagPickList.push(true);
        }
        else { _revisedFlagPickList.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagPickList.push(true);
        }
        else { _requestedFlagPickList.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagPickList.includes(true)) && (_revisedFlagPickList.includes(true)) && (_plannedFlagPickList.includes(true))) {
        _templateHeaderPickList = this.templateHeader(6);
        let resPickList1 = _tmpPickList.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resPickList1.length; i++) {
          let _tmp = Object.values(resPickList1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resPickList.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagPickList.includes(true)) && (_revisedFlagPickList.includes(true)) && (_plannedFlagPickList.includes(false))) {
        _templateHeaderPickList = this.templateHeader(5);
        let resPickList1 = _tmpPickList.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resPickList1.length; i++) {
          let _tmp = Object.values(resPickList1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resPickList.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagPickList.includes(true)) && (_plannedFlagPickList.includes(true)) && (_revisedFlagPickList.includes(false))) {
        _templateHeaderPickList = this.templateHeader(7);
        let resPickList1 = _tmpPickList.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resPickList1.length; i++) {
          let _tmp = Object.values(resPickList1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resPickList.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagPickList.includes(true)) && (_plannedFlagPickList.includes(true)) && (_requestedFlagPickList.includes(false))) {
        _templateHeaderPickList = this.templateHeader(4);
        let resPickList1 = _tmpPickList.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resPickList1.length; i++) {
          let _tmp = Object.values(resPickList1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resPickList.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagPickList.includes(true)) && (_plannedFlagPickList.includes(false)) && (_revisedFlagPickList.includes(false))) {
        _templateHeaderPickList = this.templateHeader(3);
        let resPickList1 = _tmpPickList.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resPickList1.length; i++) {
          let _tmp = Object.values(resPickList1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resPickList.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagPickList.includes(false)) && (_plannedFlagPickList.includes(true)) && (_revisedFlagPickList.includes(false))) {
        _templateHeaderPickList = this.templateHeader(1);
        let resPickList1 = _tmpPickList.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resPickList1.length; i++) {
          let _tmp = Object.values(resPickList1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resPickList.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagPickList.includes(false)) && (_plannedFlagPickList.includes(false)) && (_revisedFlagPickList.includes(true))) {
        _templateHeaderPickList = this.templateHeader(2);
        let resPickList1 = _tmpPickList.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resPickList1.length; i++) {
          let _tmp = Object.values(resPickList1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resPickList.push(_tmp);
        }
      }

    }

    /// CT last Receipt
    let resCTRecpt = [];
    if (this.purchaseMatRecpData.PurchaseKpi != null) {
      let _tmpCTRecpt = this.purchaseMatRecpData.PurchaseKpi.filter(e => e.kpiName.match("CT Last Receipt"));
      let _plannedFlagCTRecpt = []; let _revisedFlagCTRecpt = []; let _requestedFlagCTRecpt = [];
      _tmpCTRecpt.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagCTRecpt.push(true);
        }
        else { _plannedFlagCTRecpt.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagCTRecpt.push(true);
        }
        else { _revisedFlagCTRecpt.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagCTRecpt.push(true);
        }
        else { _requestedFlagCTRecpt.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagCTRecpt.includes(true)) && (_revisedFlagCTRecpt.includes(true)) && (_plannedFlagCTRecpt.includes(true))) {
        _templateHeaderCTRecpt = this.templateHeader(6);
        let resCTRecpt1 = _tmpCTRecpt.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resCTRecpt1.length; i++) {
          let _tmp = Object.values(resCTRecpt1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resCTRecpt.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagCTRecpt.includes(true)) && (_revisedFlagCTRecpt.includes(true)) && (_plannedFlagCTRecpt.includes(false))) {
        _templateHeaderCTRecpt = this.templateHeader(5);
        let resCTRecpt1 = _tmpCTRecpt.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resCTRecpt1.length; i++) {
          let _tmp = Object.values(resCTRecpt1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resCTRecpt.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagCTRecpt.includes(true)) && (_plannedFlagCTRecpt.includes(true)) && (_revisedFlagCTRecpt.includes(false))) {
        _templateHeaderCTRecpt = this.templateHeader(7);
        let resCTRecpt1 = _tmpCTRecpt.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resCTRecpt1.length; i++) {
          let _tmp = Object.values(resCTRecpt1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resCTRecpt.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagCTRecpt.includes(true)) && (_plannedFlagCTRecpt.includes(true)) && (_requestedFlagCTRecpt.includes(false))) {
        _templateHeaderCTRecpt = this.templateHeader(4);
        let resCTRecpt1 = _tmpCTRecpt.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resCTRecpt1.length; i++) {
          let _tmp = Object.values(resCTRecpt1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resCTRecpt.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagCTRecpt.includes(true)) && (_plannedFlagCTRecpt.includes(false)) && (_revisedFlagCTRecpt.includes(false))) {
        _templateHeaderCTRecpt = this.templateHeader(3);
        let resCTRecpt1 = _tmpCTRecpt.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resCTRecpt1.length; i++) {
          let _tmp = Object.values(resCTRecpt1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resCTRecpt.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagCTRecpt.includes(false)) && (_plannedFlagCTRecpt.includes(true)) && (_revisedFlagCTRecpt.includes(false))) {
        _templateHeaderCTRecpt = this.templateHeader(1);
        let resCTRecpt1 = _tmpCTRecpt.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resCTRecpt1.length; i++) {
          let _tmp = Object.values(resCTRecpt1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resCTRecpt.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagCTRecpt.includes(false)) && (_plannedFlagCTRecpt.includes(false)) && (_revisedFlagCTRecpt.includes(true))) {
        _templateHeaderCTRecpt = this.templateHeader(2);
        let resCTRecpt1 = _tmpCTRecpt.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resCTRecpt1.length; i++) {
          let _tmp = Object.values(resCTRecpt1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resCTRecpt.push(_tmp);
        }
      }
    }
    /// Breaker
    let resBreaker = [];
    if (this.purchaseMatRecpData.PurchaseKpi != null) {
      let _tmpBreaker = this.purchaseMatRecpData.PurchaseKpi.filter(e => e.kpiName.match("Breaker"));
      let _plannedFlagBreaker = []; let _revisedFlagBreaker = []; let _requestedFlagBreaker = [];
      _tmpBreaker.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagBreaker.push(true);
        }
        else { _plannedFlagBreaker.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagBreaker.push(true);
        }
        else { _revisedFlagBreaker.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagBreaker.push(true);
        }
        else { _requestedFlagBreaker.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagBreaker.includes(true)) && (_revisedFlagBreaker.includes(true)) && (_plannedFlagBreaker.includes(true))) {
        _templateHeaderBreaker = this.templateHeader(6);
        let resBreaker1 = _tmpBreaker.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resBreaker1.length; i++) {
          let _tmp = Object.values(resBreaker1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resBreaker.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagBreaker.includes(true)) && (_revisedFlagBreaker.includes(true)) && (_plannedFlagBreaker.includes(false))) {
        _templateHeaderBreaker = this.templateHeader(5);
        let resBreaker1 = _tmpBreaker.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resBreaker1.length; i++) {
          let _tmp = Object.values(resBreaker1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resBreaker.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagBreaker.includes(true)) && (_plannedFlagBreaker.includes(true)) && (_revisedFlagBreaker.includes(false))) {
        _templateHeaderBreaker = this.templateHeader(7);
        let resBreaker1 = _tmpBreaker.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resBreaker1.length; i++) {
          let _tmp = Object.values(resBreaker1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resBreaker.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagBreaker.includes(true)) && (_plannedFlagBreaker.includes(true)) && (_requestedFlagBreaker.includes(false))) {
        _templateHeaderBreaker = this.templateHeader(4);
        let resBreaker1 = _tmpBreaker.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resBreaker1.length; i++) {
          let _tmp = Object.values(resBreaker1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resBreaker.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagBreaker.includes(true)) && (_plannedFlagBreaker.includes(false)) && (_revisedFlagBreaker.includes(false))) {
        _templateHeaderBreaker = this.templateHeader(3);
        let resBreaker1 = _tmpBreaker.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resBreaker1.length; i++) {
          let _tmp = Object.values(resBreaker1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resBreaker.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagBreaker.includes(false)) && (_plannedFlagBreaker.includes(true)) && (_revisedFlagBreaker.includes(false))) {
        _templateHeaderBreaker = this.templateHeader(1);
        let resBreaker1 = _tmpBreaker.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resBreaker1.length; i++) {
          let _tmp = Object.values(resBreaker1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resBreaker.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagBreaker.includes(false)) && (_plannedFlagBreaker.includes(false)) && (_revisedFlagBreaker.includes(true))) {
        _templateHeaderBreaker = this.templateHeader(2);
        let resBreaker1 = _tmpBreaker.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resBreaker1.length; i++) {
          let _tmp = Object.values(resBreaker1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resBreaker.push(_tmp);
        }
      }
    }

    /// Relay
    let resRelay = [];
    if (this.purchaseMatRecpData.PurchaseKpi != null) {
      let _tmpRelay = this.purchaseMatRecpData.PurchaseKpi.filter(e => e.kpiName.match("Relay"));
      let _plannedFlagRelay = []; let _revisedFlagRelay = []; let _requestedFlagRelay = [];
      _tmpRelay.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagRelay.push(true);
        }
        else { _plannedFlagRelay.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagRelay.push(true);
        }
        else { _revisedFlagRelay.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagRelay.push(true);
        }
        else { _requestedFlagRelay.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagRelay.includes(true)) && (_revisedFlagRelay.includes(true)) && (_plannedFlagRelay.includes(true))) {
        _templateHeaderRelay = this.templateHeader(6);
        let resRelay1 = _tmpRelay.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resRelay1.length; i++) {
          let _tmp = Object.values(resRelay1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resRelay.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagRelay.includes(true)) && (_revisedFlagRelay.includes(true)) && (_plannedFlagRelay.includes(false))) {
        _templateHeaderRelay = this.templateHeader(5);
        let resRelay1 = _tmpRelay.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resRelay1.length; i++) {
          let _tmp = Object.values(resRelay1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resRelay.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagRelay.includes(true)) && (_plannedFlagRelay.includes(true)) && (_revisedFlagRelay.includes(false))) {
        _templateHeaderRelay = this.templateHeader(7);
        let resRelay1 = _tmpRelay.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resRelay1.length; i++) {
          let _tmp = Object.values(resRelay1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resRelay.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagRelay.includes(true)) && (_plannedFlagRelay.includes(true)) && (_requestedFlagRelay.includes(false))) {
        _templateHeaderRelay = this.templateHeader(4);
        let resRelay1 = _tmpRelay.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resRelay1.length; i++) {
          let _tmp = Object.values(resRelay1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resRelay.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagRelay.includes(true)) && (_plannedFlagRelay.includes(false)) && (_revisedFlagRelay.includes(false))) {
        _templateHeaderRelay = this.templateHeader(3);
        let resRelay1 = _tmpRelay.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resRelay1.length; i++) {
          let _tmp = Object.values(resRelay1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resRelay.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagRelay.includes(false)) && (_plannedFlagRelay.includes(true)) && (_revisedFlagRelay.includes(false))) {
        _templateHeaderRelay = this.templateHeader(1);
        let resRelay1 = _tmpRelay.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resRelay1.length; i++) {
          let _tmp = Object.values(resRelay1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resRelay.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagRelay.includes(false)) && (_plannedFlagRelay.includes(false)) && (_revisedFlagRelay.includes(true))) {
        _templateHeaderRelay = this.templateHeader(2);
        let resRelay1 = _tmpRelay.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resRelay1.length; i++) {
          let _tmp = Object.values(resRelay1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resRelay.push(_tmp);
        }
      }
    }

    /// MB
    let resMB = [];
    if (this.purchaseMatRecpData.PurchaseKpi != null) {
      let _tmpMB = this.purchaseMatRecpData.PurchaseKpi.filter(e => e.kpiName.match("MB"));
      let _plannedFlagMB = []; let _revisedFlagMB = []; let _requestedFlagMB = [];
      _tmpMB.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagMB.push(true);
        }
        else { _plannedFlagMB.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagMB.push(true);
        }
        else { _revisedFlagMB.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagMB.push(true);
        }
        else { _requestedFlagMB.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagMB.includes(true)) && (_revisedFlagMB.includes(true)) && (_plannedFlagMB.includes(true))) {
        _templateHeaderMB = this.templateHeader(6);
        let resMB1 = _tmpMB.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMB1.length; i++) {
          let _tmp = Object.values(resMB1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMB.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagMB.includes(true)) && (_revisedFlagMB.includes(true)) && (_plannedFlagMB.includes(false))) {
        _templateHeaderMB = this.templateHeader(5);
        let resMB1 = _tmpMB.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMB1.length; i++) {
          let _tmp = Object.values(resMB1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMB.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagMB.includes(true)) && (_plannedFlagMB.includes(true)) && (_revisedFlagMB.includes(false))) {
        _templateHeaderMB = this.templateHeader(7);
        let resMB1 = _tmpMB.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMB1.length; i++) {
          let _tmp = Object.values(resMB1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMB.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagMB.includes(true)) && (_plannedFlagMB.includes(true)) && (_requestedFlagMB.includes(false))) {
        _templateHeaderMB = this.templateHeader(4);
        let resMB1 = _tmpMB.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMB1.length; i++) {
          let _tmp = Object.values(resMB1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMB.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagMB.includes(true)) && (_plannedFlagMB.includes(false)) && (_revisedFlagMB.includes(false))) {
        _templateHeaderMB = this.templateHeader(3);
        let resMB1 = _tmpMB.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMB1.length; i++) {
          let _tmp = Object.values(resMB1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMB.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagMB.includes(false)) && (_plannedFlagMB.includes(true)) && (_revisedFlagMB.includes(false))) {
        _templateHeaderMB = this.templateHeader(1);
        let resMB1 = _tmpMB.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMB1.length; i++) {
          let _tmp = Object.values(resMB1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMB.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagMB.includes(false)) && (_plannedFlagMB.includes(false)) && (_revisedFlagMB.includes(true))) {
        _templateHeaderMB = this.templateHeader(2);
        let resMB1 = _tmpMB.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMB1.length; i++) {
          let _tmp = Object.values(resMB1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMB.push(_tmp);
        }
      }
    }

    /// MatDisp
    let resMatDisp = [];
    if (this.storeData.StoreKpi != null) {
      let _tmpMatDisp = this.storeData.StoreKpi.filter(e => e.kpiName.match("Material issue to dispatch"));
      let _plannedFlagMatDisp = []; let _revisedFlagMatDisp = []; let _requestedFlagMatDisp = [];
      _tmpMatDisp.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagMatDisp.push(true);
        }
        else { _plannedFlagMatDisp.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagMatDisp.push(true);
        }
        else { _revisedFlagMatDisp.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagMatDisp.push(true);
        }
        else { _requestedFlagMatDisp.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagMatDisp.includes(true)) && (_revisedFlagMatDisp.includes(true)) && (_plannedFlagMatDisp.includes(true))) {
        _templateHeaderMatDisp = this.templateHeader(6);
        let resMatDisp1 = _tmpMatDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatDisp1.length; i++) {
          let _tmp = Object.values(resMatDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatDisp.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagMatDisp.includes(true)) && (_revisedFlagMatDisp.includes(true)) && (_plannedFlagMatDisp.includes(false))) {
        _templateHeaderMatDisp = this.templateHeader(5);
        let resMatDisp1 = _tmpMatDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatDisp1.length; i++) {
          let _tmp = Object.values(resMatDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatDisp.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagMatDisp.includes(true)) && (_plannedFlagMatDisp.includes(true)) && (_revisedFlagMatDisp.includes(false))) {
        _templateHeaderMatDisp = this.templateHeader(7);
        let resMatDisp1 = _tmpMatDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatDisp1.length; i++) {
          let _tmp = Object.values(resMatDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatDisp.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagMatDisp.includes(true)) && (_plannedFlagMatDisp.includes(true)) && (_requestedFlagMatDisp.includes(false))) {
        _templateHeaderMatDisp = this.templateHeader(4);
        let resMatDisp1 = _tmpMatDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatDisp1.length; i++) {
          let _tmp = Object.values(resMatDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatDisp.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagMatDisp.includes(true)) && (_plannedFlagMatDisp.includes(false)) && (_revisedFlagMatDisp.includes(false))) {
        _templateHeaderMatDisp = this.templateHeader(3);
        let resMatDisp1 = _tmpMatDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatDisp1.length; i++) {
          let _tmp = Object.values(resMatDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatDisp.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagMatDisp.includes(false)) && (_plannedFlagMatDisp.includes(true)) && (_revisedFlagMatDisp.includes(false))) {
        _templateHeaderMatDisp = this.templateHeader(1);
        let resMatDisp1 = _tmpMatDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatDisp1.length; i++) {
          let _tmp = Object.values(resMatDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatDisp.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagMatDisp.includes(false)) && (_plannedFlagMatDisp.includes(false)) && (_revisedFlagMatDisp.includes(true))) {
        _templateHeaderMatDisp = this.templateHeader(2);
        let resMatDisp1 = _tmpMatDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatDisp1.length; i++) {
          let _tmp = Object.values(resMatDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatDisp.push(_tmp);
        }
      }
    }

    /// MatLine
    let resMatLine = [];
    if (this.storeData.StoreKpi != null) {
      let _tmpMatLine = this.storeData.StoreKpi.filter(e => e.kpiName.match("Material issue to line"));
      let _plannedFlagMatLine = []; let _revisedFlagMatLine = []; let _requestedFlagMatLine = [];
      _tmpMatLine.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagMatLine.push(true);
        }
        else { _plannedFlagMatLine.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagMatLine.push(true);
        }
        else { _revisedFlagMatLine.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagMatLine.push(true);
        }
        else { _requestedFlagMatLine.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagMatLine.includes(true)) && (_revisedFlagMatLine.includes(true)) && (_plannedFlagMatLine.includes(true))) {
        _templateHeaderMatLine = this.templateHeader(6);
        let resMatLine1 = _tmpMatLine.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatLine1.length; i++) {
          let _tmp = Object.values(resMatLine1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatLine.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagMatLine.includes(true)) && (_revisedFlagMatLine.includes(true)) && (_plannedFlagMatLine.includes(false))) {
        _templateHeaderMatLine = this.templateHeader(5);
        let resMatLine1 = _tmpMatLine.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatLine1.length; i++) {
          let _tmp = Object.values(resMatLine1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatLine.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagMatLine.includes(true)) && (_plannedFlagMatLine.includes(true)) && (_revisedFlagMatLine.includes(false))) {
        _templateHeaderMatLine = this.templateHeader(7);
        let resMatLine1 = _tmpMatLine.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatLine1.length; i++) {
          let _tmp = Object.values(resMatLine1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatLine.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagMatLine.includes(true)) && (_plannedFlagMatLine.includes(true)) && (_requestedFlagMatLine.includes(false))) {
        _templateHeaderMatLine = this.templateHeader(4);
        let resMatLine1 = _tmpMatLine.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatLine1.length; i++) {
          let _tmp = Object.values(resMatLine1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatLine.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagMatLine.includes(true)) && (_plannedFlagMatLine.includes(false)) && (_revisedFlagMatLine.includes(false))) {
        _templateHeaderMatLine = this.templateHeader(3);
        let resMatLine1 = _tmpMatLine.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatLine1.length; i++) {
          let _tmp = Object.values(resMatLine1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatLine.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagMatLine.includes(false)) && (_plannedFlagMatLine.includes(true)) && (_revisedFlagMatLine.includes(false))) {
        _templateHeaderMatLine = this.templateHeader(1);
        let resMatLine1 = _tmpMatLine.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatLine1.length; i++) {
          let _tmp = Object.values(resMatLine1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatLine.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagMatLine.includes(false)) && (_plannedFlagMatLine.includes(false)) && (_revisedFlagMatLine.includes(true))) {
        _templateHeaderMatLine = this.templateHeader(2);
        let resMatLine1 = _tmpMatLine.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMatLine1.length; i++) {
          let _tmp = Object.values(resMatLine1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMatLine.push(_tmp);
        }
      }
    }

    /// ActLineLoad
    let resActLineLoad = [];
    if (this.productionData.ProdKpi != null) {
      let _tmpActLineLoad = this.productionData.ProdKpi.filter(e => e.kpiName.match("Actual line loading"));
      let _plannedFlagActLineLoad = []; let _revisedFlagActLineLoad = []; let _requestedFlagActLineLoad = [];
      _tmpActLineLoad.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagActLineLoad.push(true);
        }
        else { _plannedFlagActLineLoad.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagActLineLoad.push(true);
        }
        else { _revisedFlagActLineLoad.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagActLineLoad.push(true);
        }
        else { _requestedFlagActLineLoad.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagActLineLoad.includes(true)) && (_revisedFlagActLineLoad.includes(true)) && (_plannedFlagActLineLoad.includes(true))) {
        _templateHeaderActLineLoad = this.templateHeader(6);
        let resActLineLoad1 = _tmpActLineLoad.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resActLineLoad1.length; i++) {
          let _tmp = Object.values(resActLineLoad1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resActLineLoad.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagActLineLoad.includes(true)) && (_revisedFlagActLineLoad.includes(true)) && (_plannedFlagActLineLoad.includes(false))) {
        _templateHeaderActLineLoad = this.templateHeader(5);
        let resActLineLoad1 = _tmpActLineLoad.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resActLineLoad1.length; i++) {
          let _tmp = Object.values(resActLineLoad1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resActLineLoad.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagActLineLoad.includes(true)) && (_plannedFlagActLineLoad.includes(true)) && (_revisedFlagActLineLoad.includes(false))) {
        _templateHeaderActLineLoad = this.templateHeader(7);
        let resActLineLoad1 = _tmpActLineLoad.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resActLineLoad1.length; i++) {
          let _tmp = Object.values(resActLineLoad1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resActLineLoad.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagActLineLoad.includes(true)) && (_plannedFlagActLineLoad.includes(true)) && (_requestedFlagActLineLoad.includes(false))) {
        _templateHeaderActLineLoad = this.templateHeader(4);
        let resActLineLoad1 = _tmpActLineLoad.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resActLineLoad1.length; i++) {
          let _tmp = Object.values(resActLineLoad1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resActLineLoad.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagActLineLoad.includes(true)) && (_plannedFlagActLineLoad.includes(false)) && (_revisedFlagActLineLoad.includes(false))) {
        _templateHeaderActLineLoad = this.templateHeader(3);
        let resActLineLoad1 = _tmpActLineLoad.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resActLineLoad1.length; i++) {
          let _tmp = Object.values(resActLineLoad1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resActLineLoad.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagActLineLoad.includes(false)) && (_plannedFlagActLineLoad.includes(true)) && (_revisedFlagActLineLoad.includes(false))) {
        _templateHeaderActLineLoad = this.templateHeader(1);
        let resActLineLoad1 = _tmpActLineLoad.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resActLineLoad1.length; i++) {
          let _tmp = Object.values(resActLineLoad1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resActLineLoad.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagActLineLoad.includes(false)) && (_plannedFlagActLineLoad.includes(false)) && (_revisedFlagActLineLoad.includes(true))) {
        _templateHeaderActLineLoad = this.templateHeader(2);
        let resActLineLoad1 = _tmpActLineLoad.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resActLineLoad1.length; i++) {
          let _tmp = Object.values(resActLineLoad1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resActLineLoad.push(_tmp);
        }
      }
    }

    /// MechStk
    let resMechStk = [];
    if (this.productionData.ProdKpi != null) {
      let _tmpMechStk = this.productionData.ProdKpi.filter(e => e.kpiName.match("Mechanical sticker"));
      let _plannedFlagMechStk = []; let _revisedFlagMechStk = []; let _requestedFlagMechStk = [];
      _tmpMechStk.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagMechStk.push(true);
        }
        else { _plannedFlagMechStk.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagMechStk.push(true);
        }
        else { _revisedFlagMechStk.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagMechStk.push(true);
        }
        else { _requestedFlagMechStk.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagMechStk.includes(true)) && (_revisedFlagMechStk.includes(true)) && (_plannedFlagMechStk.includes(true))) {
        _templateHeaderMechStk = this.templateHeader(6);
        let resMechStk1 = _tmpMechStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechStk1.length; i++) {
          let _tmp = Object.values(resMechStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechStk.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagMechStk.includes(true)) && (_revisedFlagMechStk.includes(true)) && (_plannedFlagMechStk.includes(false))) {
        _templateHeaderMechStk = this.templateHeader(5);
        let resMechStk1 = _tmpMechStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechStk1.length; i++) {
          let _tmp = Object.values(resMechStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechStk.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagMechStk.includes(true)) && (_plannedFlagMechStk.includes(true)) && (_revisedFlagMechStk.includes(false))) {
        _templateHeaderMechStk = this.templateHeader(7);
        let resMechStk1 = _tmpMechStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechStk1.length; i++) {
          let _tmp = Object.values(resMechStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechStk.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagMechStk.includes(true)) && (_plannedFlagMechStk.includes(true)) && (_requestedFlagMechStk.includes(false))) {
        _templateHeaderMechStk = this.templateHeader(4);
        let resMechStk1 = _tmpMechStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechStk1.length; i++) {
          let _tmp = Object.values(resMechStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechStk.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagMechStk.includes(true)) && (_plannedFlagMechStk.includes(false)) && (_revisedFlagMechStk.includes(false))) {
        _templateHeaderMechStk = this.templateHeader(3);
        let resMechStk1 = _tmpMechStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechStk1.length; i++) {
          let _tmp = Object.values(resMechStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechStk.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagMechStk.includes(false)) && (_plannedFlagMechStk.includes(true)) && (_revisedFlagMechStk.includes(false))) {
        _templateHeaderMechStk = this.templateHeader(1);
        let resMechStk1 = _tmpMechStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechStk1.length; i++) {
          let _tmp = Object.values(resMechStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechStk.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagMechStk.includes(false)) && (_plannedFlagMechStk.includes(false)) && (_revisedFlagMechStk.includes(true))) {
        _templateHeaderMechStk = this.templateHeader(2);
        let resMechStk1 = _tmpMechStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechStk1.length; i++) {
          let _tmp = Object.values(resMechStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechStk.push(_tmp);
        }
      }
    }

    /// MechElec
    let resMechElec = [];
    if (this.qualityData.QualityKpi != null) {
      let _tmpMechElec = this.qualityData.QualityKpi.filter(e => e.kpiName.match("Mechanical/electrical testing"));
      let _plannedFlagMechElec = []; let _revisedFlagMechElec = []; let _requestedFlagMechElec = [];
      _tmpMechElec.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagMechElec.push(true);
        }
        else { _plannedFlagMechElec.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagMechElec.push(true);
        }
        else { _revisedFlagMechElec.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagMechElec.push(true);
        }
        else { _requestedFlagMechElec.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagMechElec.includes(true)) && (_revisedFlagMechElec.includes(true)) && (_plannedFlagMechElec.includes(true))) {
        _templateHeaderMechElec = this.templateHeader(6);
        let resMechElec1 = _tmpMechElec.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechElec1.length; i++) {
          let _tmp = Object.values(resMechElec1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechElec.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagMechElec.includes(true)) && (_revisedFlagMechElec.includes(true)) && (_plannedFlagMechElec.includes(false))) {
        _templateHeaderMechElec = this.templateHeader(5);
        let resMechElec1 = _tmpMechElec.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechElec1.length; i++) {
          let _tmp = Object.values(resMechElec1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechElec.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagMechElec.includes(true)) && (_plannedFlagMechElec.includes(true)) && (_revisedFlagMechElec.includes(false))) {
        _templateHeaderMechElec = this.templateHeader(7);
        let resMechElec1 = _tmpMechElec.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechElec1.length; i++) {
          let _tmp = Object.values(resMechElec1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechElec.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagMechElec.includes(true)) && (_plannedFlagMechElec.includes(true)) && (_requestedFlagMechElec.includes(false))) {
        _templateHeaderMechElec = this.templateHeader(4);
        let resMechElec1 = _tmpMechElec.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechElec1.length; i++) {
          let _tmp = Object.values(resMechElec1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechElec.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagMechElec.includes(true)) && (_plannedFlagMechElec.includes(false)) && (_revisedFlagMechElec.includes(false))) {
        _templateHeaderMechElec = this.templateHeader(3);
        let resMechElec1 = _tmpMechElec.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechElec1.length; i++) {
          let _tmp = Object.values(resMechElec1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechElec.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagMechElec.includes(false)) && (_plannedFlagMechElec.includes(true)) && (_revisedFlagMechElec.includes(false))) {
        _templateHeaderMechElec = this.templateHeader(1);
        let resMechElec1 = _tmpMechElec.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechElec1.length; i++) {
          let _tmp = Object.values(resMechElec1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechElec.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagMechElec.includes(false)) && (_plannedFlagMechElec.includes(false)) && (_revisedFlagMechElec.includes(true))) {
        _templateHeaderMechElec = this.templateHeader(2);
        let resMechElec1 = _tmpMechElec.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resMechElec1.length; i++) {
          let _tmp = Object.values(resMechElec1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resMechElec.push(_tmp);
        }
      }
    }

    /// FAT
    let resFAT = [];
    if (this.qualityData.QualityKpi != null) {
      let _tmpFAT = this.qualityData.QualityKpi.filter(e => e.kpiName.match("FAT requested date"));
      let _plannedFlagFAT = []; let _revisedFlagFAT = []; let _requestedFlagFAT = [];
      _tmpFAT.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagFAT.push(true);
        }
        else { _plannedFlagFAT.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagFAT.push(true);
        }
        else { _revisedFlagFAT.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagFAT.push(true);
        }
        else { _requestedFlagFAT.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagFAT.includes(true)) && (_revisedFlagFAT.includes(true)) && (_plannedFlagFAT.includes(true))) {
        _templateHeaderFAT = this.templateHeader(6);
        let resFAT1 = _tmpFAT.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resFAT1.length; i++) {
          let _tmp = Object.values(resFAT1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resFAT.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagFAT.includes(true)) && (_revisedFlagFAT.includes(true)) && (_plannedFlagFAT.includes(false))) {
        _templateHeaderFAT = this.templateHeader(5);
        let resFAT1 = _tmpFAT.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resFAT1.length; i++) {
          let _tmp = Object.values(resFAT1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resFAT.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagFAT.includes(true)) && (_plannedFlagFAT.includes(true)) && (_revisedFlagFAT.includes(false))) {
        _templateHeaderFAT = this.templateHeader(7);
        let resFAT1 = _tmpFAT.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resFAT1.length; i++) {
          let _tmp = Object.values(resFAT1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resFAT.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagFAT.includes(true)) && (_plannedFlagFAT.includes(true)) && (_requestedFlagFAT.includes(false))) {
        _templateHeaderFAT = this.templateHeader(4);
        let resFAT1 = _tmpFAT.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resFAT1.length; i++) {
          let _tmp = Object.values(resFAT1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resFAT.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagFAT.includes(true)) && (_plannedFlagFAT.includes(false)) && (_revisedFlagFAT.includes(false))) {
        _templateHeaderFAT = this.templateHeader(3);
        let resFAT1 = _tmpFAT.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resFAT1.length; i++) {
          let _tmp = Object.values(resFAT1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resFAT.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagFAT.includes(false)) && (_plannedFlagFAT.includes(true)) && (_revisedFlagFAT.includes(false))) {
        _templateHeaderFAT = this.templateHeader(1);
        let resFAT1 = _tmpFAT.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resFAT1.length; i++) {
          let _tmp = Object.values(resFAT1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resFAT.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagFAT.includes(false)) && (_plannedFlagFAT.includes(false)) && (_revisedFlagFAT.includes(true))) {
        _templateHeaderFAT = this.templateHeader(2);
        let resFAT1 = _tmpFAT.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resFAT1.length; i++) {
          let _tmp = Object.values(resFAT1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resFAT.push(_tmp);
        }
      }
    }

    /// GreenStk
    let resGreenStk = [];
    if (this.qualityData.QualityKpi != null) {
      let _tmpGreenStk = this.qualityData.QualityKpi.filter(e => e.kpiName.match("Green Sticker"));
      let _plannedFlagGreenStk = []; let _revisedFlagGreenStk = []; let _requestedFlagGreenStk = [];
      _tmpGreenStk.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagGreenStk.push(true);
        }
        else { _plannedFlagGreenStk.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagGreenStk.push(true);
        }
        else { _revisedFlagGreenStk.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagGreenStk.push(true);
        }
        else { _requestedFlagGreenStk.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagGreenStk.includes(true)) && (_revisedFlagGreenStk.includes(true)) && (_plannedFlagGreenStk.includes(true))) {
        _templateHeaderGreenStk = this.templateHeader(6);
        let resGreenStk1 = _tmpGreenStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resGreenStk1.length; i++) {
          let _tmp = Object.values(resGreenStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resGreenStk.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagGreenStk.includes(true)) && (_revisedFlagGreenStk.includes(true)) && (_plannedFlagGreenStk.includes(false))) {
        _templateHeaderGreenStk = this.templateHeader(5);
        let resGreenStk1 = _tmpGreenStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resGreenStk1.length; i++) {
          let _tmp = Object.values(resGreenStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resGreenStk.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagGreenStk.includes(true)) && (_plannedFlagGreenStk.includes(true)) && (_revisedFlagGreenStk.includes(false))) {
        _templateHeaderGreenStk = this.templateHeader(7);
        let resGreenStk1 = _tmpGreenStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resGreenStk1.length; i++) {
          let _tmp = Object.values(resGreenStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resGreenStk.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagGreenStk.includes(true)) && (_plannedFlagGreenStk.includes(true)) && (_requestedFlagGreenStk.includes(false))) {
        _templateHeaderGreenStk = this.templateHeader(4);
        let resGreenStk1 = _tmpGreenStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resGreenStk1.length; i++) {
          let _tmp = Object.values(resGreenStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resGreenStk.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagGreenStk.includes(true)) && (_plannedFlagGreenStk.includes(false)) && (_revisedFlagGreenStk.includes(false))) {
        _templateHeaderGreenStk = this.templateHeader(3);
        let resGreenStk1 = _tmpGreenStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resGreenStk1.length; i++) {
          let _tmp = Object.values(resGreenStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resGreenStk.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagGreenStk.includes(false)) && (_plannedFlagGreenStk.includes(true)) && (_revisedFlagGreenStk.includes(false))) {
        _templateHeaderGreenStk = this.templateHeader(1);
        let resGreenStk1 = _tmpGreenStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resGreenStk1.length; i++) {
          let _tmp = Object.values(resGreenStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resGreenStk.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagGreenStk.includes(false)) && (_plannedFlagGreenStk.includes(false)) && (_revisedFlagGreenStk.includes(true))) {
        _templateHeaderGreenStk = this.templateHeader(2);
        let resGreenStk1 = _tmpGreenStk.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resGreenStk1.length; i++) {
          let _tmp = Object.values(resGreenStk1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resGreenStk.push(_tmp);
        }
      }
    }

    /// Disp
    let resDisp = [];
    if (this.logisticData.LogisticKpi != null) {
      let _tmpDisp = this.logisticData.LogisticKpi.filter(e => e.kpiName.match("Dispatch"));
      let _plannedFlagDisp = []; let _revisedFlagDisp = []; let _requestedFlagDisp = [];
      _tmpDisp.forEach((e) => {
        if (e.plannedDate != null) {
          _plannedFlagDisp.push(true);
        }
        else { _plannedFlagDisp.push(false); }

        if (e.revisedDate != null) {
          _revisedFlagDisp.push(true);
        }
        else { _revisedFlagDisp.push(false); }

        if (e.requestedDate != null) {
          _requestedFlagDisp.push(true);
        }
        else { _requestedFlagDisp.push(false); }
      });

      // Req Rev Planned
      if ((_requestedFlagDisp.includes(true)) && (_revisedFlagDisp.includes(true)) && (_plannedFlagDisp.includes(true))) {
        _templateHeaderDisp = this.templateHeader(6);
        let resDisp1 = _tmpDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resDisp1.length; i++) {
          let _tmp = Object.values(resDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resDisp.push(_tmp);
        }
      }
      // Req Rev 
      else if ((_requestedFlagDisp.includes(true)) && (_revisedFlagDisp.includes(true)) && (_plannedFlagDisp.includes(false))) {
        _templateHeaderDisp = this.templateHeader(5);
        let resDisp1 = _tmpDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resDisp1.length; i++) {
          let _tmp = Object.values(resDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resDisp.push(_tmp);
        }
      }
      // Req Planned
      else if ((_requestedFlagDisp.includes(true)) && (_plannedFlagDisp.includes(true)) && (_revisedFlagDisp.includes(false))) {
        _templateHeaderDisp = this.templateHeader(7);
        let resDisp1 = _tmpDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resDisp1.length; i++) {
          let _tmp = Object.values(resDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resDisp.push(_tmp);
        }
      }
      // Rev Planned
      else if ((_revisedFlagDisp.includes(true)) && (_plannedFlagDisp.includes(true)) && (_requestedFlagDisp.includes(false))) {
        _templateHeaderDisp = this.templateHeader(4);
        let resDisp1 = _tmpDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resDisp1.length; i++) {
          let _tmp = Object.values(resDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resDisp.push(_tmp);
        }
      }
      // Req
      else if ((_requestedFlagDisp.includes(true)) && (_plannedFlagDisp.includes(false)) && (_revisedFlagDisp.includes(false))) {
        _templateHeaderDisp = this.templateHeader(3);
        let resDisp1 = _tmpDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, requestedDate, actualDate, diff, reason }));
        for (let i = 0; i < resDisp1.length; i++) {
          let _tmp = Object.values(resDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resDisp.push(_tmp);
        }
      }
      // Planned
      else if ((_requestedFlagDisp.includes(false)) && (_plannedFlagDisp.includes(true)) && (_revisedFlagDisp.includes(false))) {
        _templateHeaderDisp = this.templateHeader(1);
        let resDisp1 = _tmpDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, plannedDate, actualDate, diff, reason }));
        for (let i = 0; i < resDisp1.length; i++) {
          let _tmp = Object.values(resDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resDisp.push(_tmp);
        }
      }
      //  Rev 
      else if ((_requestedFlagDisp.includes(false)) && (_plannedFlagDisp.includes(false)) && (_revisedFlagDisp.includes(true))) {
        _templateHeaderDisp = this.templateHeader(2);
        let resDisp1 = _tmpDisp.map(({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }) =>
          ({ manfMonth, kpiName, custName, soNo, ssoNo, newSaleOrderNo, variantType, qtyPanel, revisedDate, actualDate, diff, reason }));
        for (let i = 0; i < resDisp1.length; i++) {
          let _tmp = Object.values(resDisp1[i]);
          for (var j = 0; j < _tmp.length; j++) {
            if (_tmp[j] != null && typeof _tmp[j] === 'object') {
              _tmp[j] = formatDate(_tmp[j], 'dd-MMM-yy', 'en-IN');
            }
          }
          resDisp.push(_tmp);
        }
      }
    }

    // let obj:any = {};
    if (resSO != null) {
      this.obj.push({ "sheetName": "SO Release", "data": { "header": _templateHeaderSORelease, "rows": resSO } });
    }
    else {
      this.obj.push({ "sheetName": "SO Release", "data": { "header": [], "rows": [] } });
    }
    if (resHom != null) {
      this.obj.push({ "sheetName": "HOM", "data": { "header": _templateHeaderHOM, "rows": resHom } });
    }
    else {
      this.obj.push({ "sheetName": "HOM", "data": { "header": [], "rows": [] } });
    }
    if (resSLD != null) {
      this.obj.push({ "sheetName": "SLD", "data": { "header": _templateHeaderSLD, "rows": resSLD } });
    }
    else {
      this.obj.push({ "sheetName": "SLD", "data": { "header": [], "rows": [] } });
    }
    if (resGA != null) {
      this.obj.push({ "sheetName": "GA", "data": { "header": _templateHeaderGA, "rows": resGA } });
    }
    else {
      this.obj.push({ "sheetName": "GA", "data": { "header": [], "rows": [] } });
    }
    if (resSCHEME != null) {
      this.obj.push({ "sheetName": "SCHEME", "data": { "header": _templateHeaderSCHEME, "rows": resSCHEME } });
    }
    else {
      this.obj.push({ "sheetName": "SCHEME", "data": { "header": [], "rows": [] } });
    }
    if (resPM != null) {
      this.obj.push({ "sheetName": "Drg Approval", "data": { "header": _templateHeaderDrawAppvl, "rows": resPM } });
    }
    else {
      this.obj.push({ "sheetName": "Drg Approval", "data": { "header": [], "rows": [] } });
    }
    if (resC40 != null) {
      this.obj.push({ "sheetName": "C40", "data": { "header": _templateHeaderC40, "rows": resC40 } });
    }
    else {
      this.obj.push({ "sheetName": "C40", "data": { "header": [], "rows": [] } });
    }
    if (resC50 != null) {
      this.obj.push({ "sheetName": "C50", "data": { "header": _templateHeaderC50, "rows": resC50 } });
    }
    else {
      this.obj.push({ "sheetName": "C50", "data": { "header": [], "rows": [] } });
    }
    if (resC60 != null) {
      this.obj.push({ "sheetName": "C60", "data": { "header": _templateHeaderC60, "rows": resC60 } });
    }
    else {
      this.obj.push({ "sheetName": "C60", "data": { "header": [], "rows": [] } });
    }
    if (resSCM != null) {
      this.obj.push({ "sheetName": "SCM KPI", "data": { "header": _templateHeaderSCM, "rows": resSCM } });
    }
    else {
      this.obj.push({ "sheetName": "SCM KPI", "data": { "header": [], "rows": [] } });
    }
    if (resPickList != null) {
      this.obj.push({ "sheetName": "Planning KPI", "data": { "header": _templateHeaderPickList, "rows": resPickList } });
    }
    else {
      this.obj.push({ "sheetName": "Planning KPI", "data": { "header": [], "rows": [] } });
    }
    if (resCTRecpt != null) {
      this.obj.push({ "sheetName": "CT Last Receipt", "data": { "header": _templateHeaderCTRecpt, "rows": resCTRecpt } });
    }
    else {
      this.obj.push({ "sheetName": "CT Last Receipt", "data": { "header": [], "rows": [] } });
    }
    if (resBreaker != null) {
      this.obj.push({ "sheetName": "Breaker", "data": { "header": _templateHeaderBreaker, "rows": resBreaker } });
    }
    else {
      this.obj.push({ "sheetName": "Breaker", "data": { "header": [], "rows": [] } });
    }
    if (resRelay != null) {
      this.obj.push({ "sheetName": "Relay", "data": { "header": _templateHeaderRelay, "rows": resRelay } });
    }
    else {
      this.obj.push({ "sheetName": "Relay", "data": { "header": [], "rows": [] } });
    }
    if (resMB != null) {
      this.obj.push({ "sheetName": "MB", "data": { "header": _templateHeaderMB, "rows": resMB } });
    }
    else {
      this.obj.push({ "sheetName": "MB", "data": { "header": [], "rows": [] } });
    }
    if (resMatDisp != null) {
      this.obj.push({ "sheetName": "Material Issue to Dispatch", "data": { "header": _templateHeaderMatDisp, "rows": resMatDisp } });
    }
    else {
      this.obj.push({ "sheetName": "Material Issue to Dispatch", "data": { "header": [], "rows": [] } });
    }
    if (resMatLine != null) {
      this.obj.push({ "sheetName": "Material Issue to Line", "data": { "header": _templateHeaderMatLine, "rows": resMatLine } });
    }
    else {
      this.obj.push({ "sheetName": "Material Issue to Line", "data": { "header": [], "rows": [] } });
    }
    if (resActLineLoad != null) {
      this.obj.push({ "sheetName": "Actual Line Loading", "data": { "header": _templateHeaderActLineLoad, "rows": resActLineLoad } });
    }
    else {
      this.obj.push({ "sheetName": "Actual Line Loading", "data": { "header": [], "rows": [] } });
    }
    if (resMechStk != null) {
      this.obj.push({ "sheetName": "Mechanical Sticker", "data": { "header": _templateHeaderMechStk, "rows": resMechStk } });
    }
    else {
      this.obj.push({ "sheetName": "Mechanical Sticker", "data": { "header": [], "rows": [] } });
    }
    if (resMechElec != null) {
      this.obj.push({ "sheetName": "Mechanical_Electrical Testing", "data": { "header": _templateHeaderMechElec, "rows": resMechElec } });
    }
    else {
      this.obj.push({ "sheetName": "Mechanical_Electrical Testing", "data": { "header": [], "rows": [] } });
    }
    if (resFAT != null) {
      this.obj.push({ "sheetName": "FAT Requested Date", "data": { "header": _templateHeaderFAT, "rows": resFAT } });
    }
    else {
      this.obj.push({ "sheetName": "FAT Requested Date", "data": { "header": [], "rows": [] } });
    }
    if (resGreenStk != null) {
      this.obj.push({ "sheetName": "Green Sticker", "data": { "header": _templateHeaderGreenStk, "rows": resGreenStk } });
    }
    else {
      this.obj.push({ "sheetName": "Green Sticker", "data": { "header": [], "rows": [] } });
    }
    if (resDisp != null) {
      this.obj.push({ "sheetName": "Dispatch", "data": { "header": _templateHeaderDisp, "rows": resDisp } });
    }
    else {
      this.obj.push({ "sheetName": "Dispatch", "data": { "header": [], "rows": [] } });
    }

  }

  _dataObj: any = '';
  downloadExcel() {
    this.exportToExcel();
    this._dataObj = JSON.stringify(this.obj);
    this.obj = [];
    setTimeout(() => {
      this.userImpFormFunct.nativeElement.submit()
    }, 10);
  }
  templateHeader(_type: number) {
    let plannedHeading =
      ["Planned Mfg Month", "KPI Name", "Customer Name", "Sale order", "Suborder", "New Sale order", "Product Variant", "Panel Qty",
        "Planned Date", "Actual Date", "Planned vs Actual", "Reason for Delay/Early"
      ];

    let revisedHeading =
      ["Planned Mfg Month", "KPI Name", "Customer Name", "Sale order", "Suborder", "New Sale order", "Product Variant", "Panel Qty",
        "Revised Date", "Actual Date", "Planned vs Actual", "Reason for Delay/Early"
      ];

    let requestedHeading =
      ["Planned Mfg Month", "KPI Name", "Customer Name", "Sale order", "Suborder", "New Sale order", "Product Variant", "Panel Qty",
        "Requested Date", "Actual Date", "Planned vs Actual", "Reason for Delay/Early"
      ];

    let planRevisedHeading =
      ["Planned Mfg Month", "KPI Name", "Customer Name", "Sale order", "Suborder", "New Sale order", "Product Variant", "Panel Qty",
        "Planned Date", "Revised Date", "Actual Date", "Planned vs Actual", "Reason for Delay/Early"
      ];

    let revisedReqHeading =
      ["Planned Mfg Month", "KPI Name", "Customer Name", "Sale order", "Suborder", "New Sale order", "Product Variant", "Panel Qty",
        "Revised Date", "Requested Date", "Actual Date", "Planned vs Actual", "Reason for Delay/Early"
      ];

    let planRequestedHeading =
      ["Planned Mfg Month", "KPI Name", "Customer Name", "Sale order", "Suborder", "New Sale order", "Product Variant", "Panel Qty",
        "Planned Date", "Requested Date", "Actual Date", "Planned vs Actual", "Reason for Delay/Early"
      ];

    let planRevisedReqHeading =
      ["Planned Mfg Month", "KPI Name", "Customer Name", "Sale order", "Suborder", "New Sale order", "Product Variant", "Panel Qty",
        "Planned Date", "Revised Date", "Requested Date", "Actual Date", "Planned vs Actual", "Reason for Delay/Early"
      ];

    switch (_type) {
      case 1:
        return plannedHeading;
        break;

      case 2:
        return revisedHeading;
        break;

      case 3:
        return requestedHeading;
        break;

      case 4:
        return planRevisedHeading;
        break;

      case 5:
        return revisedReqHeading;
        break;

      case 6:
        return planRevisedReqHeading;
        break;
      case 7:
        return planRequestedHeading;
        break;
    }
  }
}
